module.exports = __webpack_public_path__ + "static/media/grid-img2.1816c934.svg";